import AppLoaderComponent from "component/global/app-core/app-loader/app-loader-component";
import { Navigate, useLocation } from "react-router-dom";
import { buildPublicLoginPath, useLoginGatePage } from "app/services/auth/loginRedirect";

const LoginRedirect = () => {
    const location = useLocation();
    const { data: loginGatePage, isLoading } = useLoginGatePage();

    if (isLoading) {
        return <AppLoaderComponent />;
    }

    const params = new URLSearchParams(location.search);
    const returnTo = params.get("returnTo") || "/";

    return <Navigate to={buildPublicLoginPath(loginGatePage, returnTo)} replace />;
};

export default LoginRedirect;
